/**
 * True when the primary input supports real hover (mouse / trackpad).
 * False on most phones — use so hover-driven UI does not steal the first tap on iOS.
 */
export function prefersFinePointerHover() {
  if (typeof window === 'undefined') return false;
  try {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  } catch {
    return false;
  }
}
